export const listDisseminationLessonService = (fetch) => async (filters) => {
  try {
    const searchParams = new URLSearchParams(Object.entries(filters)).toString();
    const response = await fetch({
      url: `/api/v1/siniestros-viales/divulgacion-lecciones?${searchParams}`,
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
